import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { DcsHealthCheckComponent } from './health.component';

export const healthRoute: Route = {
  path: 'dcs-health',
  component: DcsHealthCheckComponent,
  data: {
    pageTitle: 'health.title'
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/health/health.route.ts